var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$mq !== "mobile" && _vm.filterGroups.length
    ? _c("div", { staticClass: "collection-filters" }, [
        _c("div", { staticClass: "collection-filters__filter-menu" }, [
          _c(
            "div",
            { staticClass: "collection-filters__filter-panels" },
            [
              _c(
                "transition-group",
                {
                  attrs: { name: "fade", duration: { enter: 600, leave: 200 } }
                },
                _vm._l(_vm.filterGroups, function(filterGroup) {
                  return !_vm.fetchingStatus.status
                    ? _c(
                        "div",
                        {
                          key: filterGroup.urlParam,
                          staticClass: "collection-filters__filter-panel"
                        },
                        [
                          _c("collection-accordion", {
                            ref: "accordion" + filterGroup.urlParam,
                            refInFor: true,
                            attrs: { iconSize: "16px", autoClose: false },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "heading",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        _vm._s(
                                          _vm.unhandleizeFilter(
                                            filterGroup.name
                                          )
                                        )
                                      ),
                                      _vm.containsCurrentFilters(
                                        filterGroup.urlParam
                                      )
                                        ? _c("span", {
                                            staticClass: "accordion__menu-title"
                                          })
                                        : _vm._e()
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _vm.containsCurrentFilters(
                                        filterGroup.urlParam
                                      )
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "collection-filters__filter-panel-clear-filters",
                                              on: {
                                                click: function($event) {
                                                  return _vm.clearFilterFilters(
                                                    filterGroup.urlParam
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Clear")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "collection-filters__filter-panel-filters"
                                        },
                                        _vm._l(
                                          _vm.returnExpandedUnexpanded(
                                            filterGroup.name
                                          ),
                                          function(filter) {
                                            return _c(
                                              "div",
                                              {
                                                key: filter.url,
                                                staticClass:
                                                  "collection-filters__filter-panel-filter"
                                              },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "input--checkbox",
                                                  attrs: {
                                                    id:
                                                      filterGroup.name +
                                                      "-" +
                                                      _vm.handleizedFilter(
                                                        filter.name
                                                      ),
                                                    type: "checkbox"
                                                  },
                                                  domProps: {
                                                    value: filter.url,
                                                    checked: _vm.isCurrentFilter(
                                                      filter.url
                                                    )
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.updateFilterArray
                                                  }
                                                }),
                                                _c("label", {
                                                  attrs: {
                                                    for:
                                                      filterGroup.name +
                                                      "-" +
                                                      _vm.handleizedFilter(
                                                        filter.name
                                                      )
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.decodedFilter(
                                                        filter.name
                                                      )
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                }),
                0
              ),
              _c(
                "fade-transition",
                { attrs: { duration: { enter: 600, leave: 200 } } },
                [
                  _vm.fetchingStatus.status
                    ? _c("collection-filters-skeleton", {
                        attrs: { collection: "b" }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    : _c(
        "div",
        { staticClass: "collection-filters" },
        [
          _c("collection-active-filters"),
          _vm.filters && _vm.filters.length
            ? _c("div", { staticClass: "collection-filters__mobile-header" })
            : _vm._e(),
          _c(
            "fade-transition",
            { attrs: { duration: { enter: 600, leave: 200 } } },
            [
              _c(
                "div",
                _vm._l(_vm.filterGroups, function(filterGroup) {
                  return !_vm.fetchingStatus.status
                    ? _c(
                        "div",
                        {
                          key: filterGroup.urlParam,
                          staticClass: "collection-filters__filter-accordion"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "collection-filters__filter-accordion-header",
                              on: {
                                click: function($event) {
                                  return _vm.setCurrentMobileFilter(
                                    filterGroup.urlParam
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "collection-filters__filter-accordion-title body-md"
                                },
                                [
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "collection-filters__filter-accordion-title-span"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.unhandleizeFilter(
                                            filterGroup.name
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm.currentFilterPanel !== filterGroup.urlParam
                                ? _c("icon", {
                                    staticClass: "vertical-aligned-icon",
                                    attrs: {
                                      name: "chevron-down",
                                      size: "12px"
                                    }
                                  })
                                : _vm._e(),
                              _vm.currentFilterPanel === filterGroup.urlParam
                                ? _c("icon", {
                                    staticClass: "vertical-aligned-icon",
                                    attrs: { name: "chevron-up", size: "12px" }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("collapse-transition", [
                            _vm.currentFilterPanel == filterGroup.urlParam
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "collection-filters__filter-panel-filters column"
                                  },
                                  _vm._l(filterGroup.values, function(filter) {
                                    return _c(
                                      "div",
                                      {
                                        key: filter.url,
                                        staticClass:
                                          "collection-filters__filter-panel-filter"
                                      },
                                      [
                                        _c("input", {
                                          staticClass:
                                            "collection-filters__filter-panel-filter-checkbox input--checkbox",
                                          attrs: {
                                            id:
                                              filterGroup.name +
                                              "-" +
                                              _vm.handleizedFilter(filter.name),
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            value: filter.url,
                                            checked: _vm.isCurrentFilter(
                                              filter.url
                                            )
                                          },
                                          on: { change: _vm.updateFilterArray }
                                        }),
                                        _c("label", {
                                          staticClass: "body-sm",
                                          attrs: {
                                            for:
                                              filterGroup.name +
                                              "-" +
                                              _vm.handleizedFilter(filter.name)
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.decodedFilter(filter.name)
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                }),
                0
              )
            ]
          ),
          _c(
            "fade-transition",
            { attrs: { duration: { enter: 600, leave: 200 } } },
            [
              _vm.fetchingStatus.status
                ? _c("collection-filters-skeleton", {
                    attrs: { collection: "b" }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }